import { ThreeDots, Oval } from "react-loader-spinner";

export const ThreeDotsSpinner = ({ isLoading }) =>
  isLoading &&  <ThreeDots height="40"  width="80"  radius="9" /*color="#58F2F0"*/  ariaLabel="three-dots-loading" visible={true}/>

export const OvalSpinner = ({isLoading, height=80}) => 
    isLoading && <Oval height={height} width={height} /*color="#58F2F0"*/ visible={true} ariaLabel='oval-loading' /*secondaryColor="#58F2F0"*/ strokeWidth={2} strokeWidthSecondary={2}/>
